import { Container } from "@mui/material";
import HeaderBreadcrumbs from "components/HeaderBreadcrumbs";
import Page from "components/Page";
import useSettings from "hooks/useSettings";
import ThemesFormContainer from "../../../../components/_dashboard/themes/ThemesFormContainer";

export default function AddEditContentTheme() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Add Edit Journey Table">
      <Container maxWidth={themeStretch ? false : "lg"}>
        <HeaderBreadcrumbs heading={"Themes content"} links={[]} />

        <ThemesFormContainer />
      </Container>
    </Page>
  );
}
